<!-- ncats branch begin -->
<div class="app-shell">
  <div class="app-shell-header">
    @if (showTopBanner) {
      <app-top-banner />
    }
    @if (!isPfdaVersion) {
      <app-header />
    } @else {
      <app-pfda-toolbar />
    }
  </div>

  <div class="app-shell-body">
    <app-main-notification />
    <app-session-expiration />
    <app-loading />
    <div class="app-shell-page">
      <router-outlet />
    </div>

    @if (showFooter) {
      <app-footer />
    }
  </div>
</div>
<!-- ncats branch end -->
